import { Map, fromJS } from 'immutable'
import {
  GET_MULTIPLE_PM_PLACEMENTS,
  GET_PM_PLACEMENT,
} from './actions'
import {
  getPmPlacementMultiple,
  getPmPlacementSingle,
} from './watchers-helpers'

/**
 * Handle get multiple page manager placements action
 */
export function onGetMultiplePmPlacements ({ after }) {
  return after(GET_MULTIPLE_PM_PLACEMENTS, async ({ dispatch, state, action }) => {
    const {
      auth = Map(), pmPlacement = Map(),
    } = state
    const { placementNames, language, sectionId } = action.payload
    await getPmPlacementMultiple({
      dispatch, placementNames: fromJS(placementNames), language, sectionId, auth, pmPlacement,
    })
  })
}


/**
 * Handle get page manager placement action
 */
export function onGetPmPlacements ({ after }) {
  return after(GET_PM_PLACEMENT, async ({ dispatch, state, action }) => {
    const {
      auth = Map(), app = Map(), page = Map(), videos = Map(), pmPlacement = Map(),
    } = state
    const { placementName, language, sectionId } = action.payload
    await getPmPlacementSingle({
      dispatch, placementName, language, sectionId, auth, app, page, videos, pmPlacement,
    })
  })
}
